var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"title"},_vm._l((_vm.tabs),function(t,i){return _c('div',{key:`tab_${i}`,staticClass:"item",attrs:{"selected":t.selected&&true},on:{"click":function($event){return _vm.change(i)}}},[_c('span',{domProps:{"textContent":_vm._s(t.name)}})])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }